/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type LandingPageFaqUpdateRequest = {
    bootCampCategory?: LandingPageFaqUpdateRequest.bootCampCategory;
    title?: string;
    sequence?: number;
    id?: number;
};

export namespace LandingPageFaqUpdateRequest {

    export enum bootCampCategory {
        ALL = 'ALL',
        SEBFE = 'SEBFE',
        SEBBE = 'SEBBE',
        UUB = 'UUB',
        GMB = 'GMB',
        DOB = 'DOB',
        PMB = 'PMB',
        BEB = 'BEB',
        AIB = 'AIB',
    }


}

